import { api } from '@api'
import { IconName } from '@components'
import { useLanguage } from '@context'
import { useQuery } from '@tanstack/react-query'

export interface Moment {
  id: string
  code: IconName
  nameEn: string
  nameFr: string
  nameEs?: string
  name?: string
}

const fetchMoments = async (lang: string): Promise<Moment[]> => {
  const { data } = await api.get<Moment[]>('/moments', { params: { lang } })
  return data
}

export const useGetMoments = () => {
  const { currentLanguage } = useLanguage()
  return useQuery<Moment[]>({
    queryKey: ['moments', currentLanguage],
    queryFn: () => fetchMoments(currentLanguage),
  })
}

